import React from 'react';
import PropTypes from 'prop-types';
import {taxGroupOptions} from "@kjdelectronics/ps-quotetool-domain/domain/taxes.canada.groups";

const TaxGroupDropdown = ({ taxGroup, onTaxGroupChange, readOnly, tabIndex }) => {
    if (readOnly) {
        // Renders a non-interactive display if readOnly is true
        return (
            <div className="tax-group-dropdown">
                <label className={"fw-bold"} style={{ marginRight: '5px' }}>Tax Group:</label>
                <span>{taxGroup ? taxGroup.name : ''}</span>
            </div>
        );
    }

    const handleChange = (event) => {
        const selectedId = parseInt(event.target.value, 10);
        const selectedOption = taxGroupOptions.find(option => option.id === selectedId);
        if (onTaxGroupChange) {
            onTaxGroupChange(selectedOption);
        }
    };

    return (
        <div className="tax-group-dropdown">
            <label htmlFor="taxGroupSelect" style={{ marginRight: '5px' }}>Tax Group:</label>
            <select
                id="taxGroupSelect"
                value={taxGroup ? taxGroup.id : ''}
                onChange={handleChange}
                tabIndex={tabIndex}
            >
                {taxGroupOptions.map(option => (
                    <option key={option.id} value={option.id}>
                        {option.name}
                    </option>
                ))}
            </select>
        </div>
    );
};

TaxGroupDropdown.propTypes = {
    taxGroup: PropTypes.shape({
        id: PropTypes.number,
        name: PropTypes.string,
    }),
    onTaxGroupChange: PropTypes.func.isRequired,
    readOnly: PropTypes.bool,
    tabIndex: PropTypes.number,
};

export default TaxGroupDropdown;